import React from 'react';
import { Sun, Moon } from 'phosphor-react';
import { useTheme } from '../../contexts/ThemeContext';

/**
 * Dark mode toggle button. Four variants:
 * - "practice" (default): teal border, teal icon — matches practice-back-button style
 * - "header": white icon, no border — matches notes-header style (green gradient bg)
 * - "floating": teal icon, floating top-right of container — for webview practice
 * - "recap": small teal icon, no border — for inline use next to recap title
 */
const DarkModeToggle = ({ variant = 'practice' }) => {
  const { isDarkMode, toggleDarkMode } = useTheme();

  const classMap = {
    practice:
      'flex items-center justify-center cursor-pointer transition-all duration-200 rounded-lg p-2 bg-transparent border-2 border-[rgba(18,118,109,0.2)] text-[var(--accent-teal)] w-[38px] h-[38px] hover:border-[#12766d] hover:bg-[rgba(18,118,109,0.05)]',
    header:
      'flex items-center justify-center cursor-pointer transition-all duration-200 rounded-lg p-1.5 bg-transparent border-none text-white hover:bg-[rgba(255,255,255,0.15)] active:bg-[rgba(255,255,255,0.25)] active:scale-95',
    floating:
      'absolute top-3 right-6 z-10 flex items-center justify-center cursor-pointer transition-all duration-200 rounded-lg p-1.5 bg-[var(--card-bg)] border-[1.5px] border-[rgba(18,118,109,0.2)] text-[var(--accent-teal)] shadow-[var(--shadow-sm)] hover:border-[#12766d] hover:bg-[rgba(18,118,109,0.05)]',
    recap:
      'flex items-center justify-center cursor-pointer transition-all duration-200 rounded-lg p-1 bg-transparent border-none text-[var(--accent-teal)] hover:bg-[rgba(18,118,109,0.08)]',
  };
  const className = classMap[variant] || classMap.practice;

  return (
    <button
      className={className}
      onClick={toggleDarkMode}
      aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDarkMode ? 'Light mode' : 'Dark mode'}
    >
      {isDarkMode ? <Sun size={20} weight="bold" /> : <Moon size={20} weight="bold" />}
    </button>
  );
};

export default DarkModeToggle;
